export default __webpack_public_path__ + "static/media/Suvyakta.25df24d2.png";